// extracted by css-extract-rspack-plugin
export default {"messageMeta":"UserProblemStatementMessage-module__messageMeta__y5RUo","messageText":"UserProblemStatementMessage-module__messageText__Jng0H"};